module.exports = __webpack_public_path__ + "static/media/game_icon_dicero.82c3aa39.png";